import { render, staticRenderFns } from "./pmPage.vue?vue&type=template&id=567a61b0&scoped=true"
import script from "./pmPage.vue?vue&type=script&lang=js"
export * from "./pmPage.vue?vue&type=script&lang=js"
import style0 from "./pmPage.vue?vue&type=style&index=0&id=567a61b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567a61b0",
  null
  
)

export default component.exports